import { SellerAccounting } from 'components/sellers/SellerAccounting/SellerAccounting'
import { useAppSelector } from 'shared/hooks/useReduxHooks'
import { appSelectors } from 'store/app'

export const ProfileAccounting: React.FC = () => {
  const sellerId = useAppSelector(appSelectors.selectSellerId)
  return <SellerAccounting type='profile' sellerId={sellerId ?? ''} />
}